import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Trash2, ExternalLink } from 'lucide-react';
import { api } from '../lib/api';

export default function Meet() {
  const qc = useQueryClient();
  const [topic, setTopic] = useState('');
  const [requireApproval, setRequireApproval] = useState(false);
  const { data: meetings = [] } = useQuery({ queryKey: ['meet'], queryFn: () => api.meet.list() });
  const create = useMutation({
    mutationFn: () => api.meet.create({ topic, require_approval: requireApproval }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['meet'] }); setTopic(''); },
  });
  const end = useMutation({
    mutationFn: (roomId: string) => api.meet.end(roomId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['meet'] }),
  });

  async function joinNow(roomId: string) {
    const r = await api.meet.join(roomId);
    window.open(r.url, '_blank');
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Meetings</h1>
      <div className="card space-y-3">
        <h2 className="font-semibold">New meeting</h2>
        <input className="input" placeholder="Topic (optional)" value={topic} onChange={e => setTopic(e.target.value)} />
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={requireApproval} onChange={e => setRequireApproval(e.target.checked)} />
          Approve participants before they join
        </label>
        <button onClick={() => create.mutate()} className="btn-primary">Create</button>
      </div>
      <div className="card p-0 overflow-hidden">
        <table className="table">
          <thead><tr><th>Topic</th><th>Organizer</th><th>Approval</th><th>Expires</th><th></th></tr></thead>
          <tbody>
            {(meetings as any[]).map((m: any) => (
              <tr key={m.meeting_uuid} className="hover:bg-elevated">
                <td>{m.topic || '(no topic)'}</td>
                <td>{m.organizer_user}</td>
                <td>{m.require_approval ? 'yes' : 'no'}</td>
                <td className="text-xs">{new Date(m.expires_at).toLocaleString()}</td>
                <td className="space-x-1 whitespace-nowrap">
                  <button onClick={() => joinNow(m.room_id)} className="btn-ghost p-1"><ExternalLink size={14} /></button>
                  <button onClick={() => end.mutate(m.room_id)} className="btn-ghost p-1 text-danger"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
